import { shallow } from 'zustand/shallow'

import ChainSelector from './ChainSelector'
import NetworkSelector from './NetworkSelector'
import { useChainAndNetwork, chainType, networkType } from 'src/store/chainAndNetwork'

const NetworkAndChainSelector = ({
  chains,
  withTitle = true,
}: {
  chains?: chainType[]
  withTitle?: boolean
}) => {
  const { chain, network, setChain, setNetwork } = useChainAndNetwork(
    (state) => ({
      chain: state.chain,
      network: state.network,
      setChain: state.setChain,
      setNetwork: state.setNetwork,
    }),
    shallow,
  )

  return (
    <div className="flex flex-col gap-4">
      {withTitle && <h2 className="text-white">Chain & Network</h2>}
      <ChainSelector
        selected={chain}
        chains={chains}
        onSelect={(newChain: chainType) => setChain(newChain)}
      />
      <NetworkSelector
        chain={chain}
        selected={network}
        onSelect={(newNetwork: networkType) => setNetwork(newNetwork)}
      />
    </div>
  )
}

export default NetworkAndChainSelector
